module.exports = __webpack_public_path__ + "img/ie_setting_01_turnoff_popup2.19495f0e.jpg";